import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/attendance";

export function listCourses(options = {}) {
  return axios.post(`${BASE}/list-courses`, listRequestBody(options));
}

export function listSessions({ courseId, year, month }) {
  return axios.post(`${BASE}/sessions/list`, { courseId, year, month });
}

export function monthlyMatrix({ courseId, year, month }) {
  return axios.post(`${BASE}/sessions/monthly-matrix`, {
    courseId,
    year,
    month,
  });
}

export function openSession({ courseId, sessionDate }) {
  return axios.post(`${BASE}/sessions/open`, { courseId, sessionDate });
}

export function commitSession({ courseId, sessionDate, sessionId, presents }) {
  return axios.post(`${BASE}/sessions/commit`, {
    courseId,
    sessionDate,
    sessionId,
    presents,
  });
}

export function getSession(sessionId) {
  return axios.get(`${BASE}/sessions/${sessionId}`);
}

export function updateMarks(sessionId, marks) {
  return axios.patch(`${BASE}/sessions/${sessionId}/marks`, { marks });
}
